import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { MapPin, Mail } from "lucide-react";
import { businessInfo } from "@/config/contentConfig";

export const LocationInfo = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <Card className="p-6 text-center">
        <CardContent className="pt-6">
          <MapPin className="w-12 h-12 text-primary mx-auto mb-4" />
          <h3 className="text-xl font-display font-semibold mb-3">Adresse</h3>
          <p className="text-muted-foreground">
            {businessInfo.location.address.street}<br />
            {businessInfo.location.address.postalCode} {businessInfo.location.address.city}<br />
            {businessInfo.location.address.country}
          </p>
        </CardContent>
      </Card>

      <Card className="p-6 text-center">
        <CardContent className="pt-6">
          <Mail className="w-12 h-12 text-fun mx-auto mb-4" />
          <h3 className="text-xl font-display font-semibold mb-3">Email</h3>
          <p className="text-muted-foreground">
            {businessInfo.company.email}<br />
            <span className="text-sm">Réponse sous {businessInfo.company.responseTime}</span>
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export const ServiceAreas = () => {
  return (
    <div className="mt-16 text-center">
      <div className="max-w-4xl mx-auto">
        <h3 className="text-2xl font-display font-bold mb-6">Zone de service</h3>
        <p className="text-lg text-muted-foreground mb-8">
          Nous desservons principalement la région de Bruxelles-Capitale et le Brabant wallon. 
          Transport facile depuis {businessInfo.location.address.city} vers toutes les communes avoisinantes.
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {businessInfo.serviceAreas.map((city, index) => (
            <Badge key={index} variant="outline" className="p-2">
              {city}
            </Badge>
          ))}
        </div>
      </div>
    </div>
  );
};